var map = {
	"./TSCShortcutLogo.svg": 43234,
	"./advancedRM.svg": 31168,
	"./appConfig.svg": 47632,
	"./bg-graphic-old.png": 60863,
	"./bg-graphic.png": 53191,
	"./candidatesShortcutLogo.svg": 9092,
	"./exportData.svg": 54915,
	"./feedback.svg": 34536,
	"./feedbackAndBugs.svg": 60922,
	"./insightsShortcutLogo.svg": 74397,
	"./onboarding.svg": 10422,
	"./openSeatsShortcutLogo.svg": 48206,
	"./penpicSearchShortcutLogo.svg": 11341,
	"./projectSearchShortcutLogo.svg": 88763,
	"./projectSnapshotShortcutLogo.svg": 61155,
	"./resourcesShortcutLogo.svg": 13379,
	"./rm.svg": 77542,
	"./urm.svg": 64533,
	"./usersLogo.svg": 97450,
	"./yourPenPicShortcutLogo.svg": 51960,
	"./yourTasksShortcutLogo.svg": 22721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4017;